/** Sub-roles that show the insurance / Lamal form (consultation step 6). */
export const INSURANCE_FORM_ROLES = ['dentist', 'pediatricdentist'];

export const hasInsuranceFormRole = (role) => INSURANCE_FORM_ROLES.includes(role);

export const shouldHideMissingTeethGridInPdf = (role) => role === 'pediatricdentist';
